// extracted by mini-css-extract-plugin
module.exports = {"divider":"HorizontalDivider_divider__LVfEs","withLine":"HorizontalDivider_withLine__9j_tk","withChildren":"HorizontalDivider_withChildren__ykDCi"};